// @flow

import { collectionsHandoverActions } from './collectionsHandoverActionCreator';

const filterTableData = (newState, searchStr) => {
  const searchString = searchStr.toLowerCase().trim();

  let filteredArr;

  if (searchString) {
    filteredArr = newState.tableData.filter(
      row =>
        (row.userName &&
          row.userName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.userMobile &&
          row.userMobile.toLowerCase().indexOf(searchString) >= 0) ||
        (row.userId && row.userId.toString().indexOf(searchString) >= 0)
    );
  } else {
    filteredArr = newState.tableData;
  }

  return filteredArr;
};

const initialState = {
  isLoading: false,
  isLoaded: false,
  tableData: null,
  tableDataFiltered: [],
  filterValues: {},
  downloadingTemplate: false,
  cnWiseHandoverData: {
    isLoading: true,
    isLoaded: false,
    tableData: null,
    tableDataFiltered: null
  },
  handover: {
    callInitiated: false,
    callCompleted: null,
    callSuccess: null,
    error: null,
    printData: null
  },
  payNearHandover: {
    callInitiated: false,
    callCompleted: null,
    callSuccess: null,
    error: null
  },
  writeOff: {
    callInitiated: false,
    callCompleted: null,
    callSuccess: null,
    error: null,
    printData: null
  }
};

const collectionsHandoverReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case collectionsHandoverActions.GET_COLLECTIONS_HANDOVER: {
      return Object.assign({}, state, action.payload);
    }
    case collectionsHandoverActions.FILTER_COLLECTIONS_HANDOVER_TABLE_DATA: {
      const newState = Object.assign({}, state);
      const filteredData = filterTableData(newState, action.payload);
      return Object.assign({}, state, { tableDataFiltered: filteredData });
    }
    case collectionsHandoverActions.SET_COLLECTIONS_HANDOVER_DATE_FILTER: {
      return Object.assign({}, state, {
        filterValues: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      });
    }
    case collectionsHandoverActions.GET_CN_WISE_HANDOVER_DETAILS: {
      return Object.assign({}, state, action.payload);
    }
    case collectionsHandoverActions.INITIATE_HANDOVER: {
      return Object.assign({}, state, action.payload);
    }
    case collectionsHandoverActions.INITIATE_PAY_NEAR_HANDOVER: {
      return Object.assign({}, state, action.payload);
    }
    case collectionsHandoverActions.DOWNLOAD_TEMPLATE: {
      return Object.assign({}, state, action.payload);
    }
    case collectionsHandoverActions.INITIATE_WRITE_OFF: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default collectionsHandoverReducer;
